import "./meteor.css";

const Connect = () => {
  const senderEmail = "alifhakimiazwan@gmail.com";

  const handleComposeEmail = () => {
    const mailtoLink = `mailto:${senderEmail}`;
    window.open(mailtoLink, "_blank");
  };
  return (
    <div className="my-8 sm:my-10 md:my-12 w-full relative mt-16 sm:mt-20 md:mt-24 py-12 sm:py-16 md:py-20 bg-gray-50 rounded-2xl flex flex-col items-center text-center overflow-hidden">
      <div className="w-full overflow-hidden">
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor rounded-[100px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-5px",
            left: "500px",
            animationDelay: "0.354689s",
            animationDuration: "4s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor2 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-5px",
            left: "550px",
            animationDelay: "0.354689s",
            animationDuration: "3s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor3 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-55px",
            left: "700px",
            animationDelay: "1.2",
            animationDuration: "2s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-16px",
            left: "0px",
            animationDelay: "0.354689s",
            animationDuration: "4s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor2 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-5px",
            left: "150px",
            animationDelay: "1.4",
            animationDuration: "4s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor3 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "15px",
            left: "264px",
            animationDelay: "2.5",
            animationDuration: "3s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "5px",
            left: "612px",
            animationDelay: "2.6",
            animationDuration: "5s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor2 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-25px",
            left: "1378px",
            animationDelay: "1.4",
            animationDuration: "4s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          className="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor3 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-15px",
            left: "658px",
            animationDelay: "0.3",
            animationDuration: "4s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor3 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-16px",
            left: "10px",
            animationDelay: "0.354689s",
            animationDuration: "3s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>

        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor rounded-[100px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-5px",
            left: "230px",
            animationDelay: "0.354689s",
            animationDuration: "5s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor2 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-5px",
            left: "350px",
            animationDelay: "0.354689s",
            animationDuration: "2s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor3 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-5px",
            left: "20px",
            animationDelay: "1.2",
            animationDuration: "4s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor3 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-16px",
            left: "100px",
            animationDelay: "0.354689s",
            animationDuration: "3s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor2 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-5px",
            left: "400px",
            animationDelay: "1.4",
            animationDuration: "2s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor3 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "15px",
            left: "370px",
            animationDelay: "2.5",
            animationDuration: "3s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor3 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "5px",
            left: "660px",
            animationDelay: "2.6",
            animationDuration: "4s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          class="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor2 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-25px",
            left: "1300px",
            animationDelay: "1.4",
            animationDuration: "5s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <span
          className="pointer-events-none absolute left-1/2 top-1/2 h-0.5 w-0.5 rotate-[215deg] meteor3 rounded-[9999px] bg-gray-500 shadow-[0_0_0_1px_#ffffff10]"
          style={{
            top: "-15px",
            left: "558px",
            animationDelay: "0.3",
            animationDuration: "2s",
          }}
        >
          <div class="pointer-events-none absolute top-1/2 -z-10 h-[1px] w-[50px] -translate-y-1/2 bg-gradient-to-r from-gray-500 to-transparent"></div>
        </span>
        <div className="flex flex-col items-center px-4">
          <div className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl mb-7 text-center">
            Let's Connect!
          </div>
          <div className="flex flex-col sm:flex-row justify-center gap-3 sm:gap-4 w-full sm:w-auto mt-5">
            <div className="relative z-10 text-black items-start rounded-xl w-full sm:w-auto bg-white r shadow-lg shadow-sky-500">
              <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
              <button
                onClick={handleComposeEmail}
                class="relative gradient-border px-4 py-2 sm:px-5 sm:py-3 rounded-xl flex items-center justify-center bg-black hover:bg-white hover:text-black opacity-95 hover:opacity-100 text-white w-full text-sm sm:text-base font-normal transform hover:scale-105 duration-300"
              >
                Send me an email
              </button>
            </div>
            <div className="relative z-10 text-black items-start rounded-xl w-full sm:w-auto bg-white r shadow-lg shadow-sky-500">
              <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl blur opacity-25 group-hover:opacity-100 transition duration-1000 group-hover:duration-200"></div>
              <a
                href="https://www.linkedin.com/in/alif-hakimi-azwan/"
                target="_blank"
                class="relative gradient-border px-4 py-2 sm:px-5 sm:py-3 rounded-xl flex items-center justify-center bg-black hover:bg-white hover:text-black opacity-95 hover:opacity-100 text-white w-full text-sm sm:text-base font-normal transform hover:scale-105 duration-300"
              >
                Connect on LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Connect;
